import { APEX_API_URL } from '@/constants';
import { getHeaderWithToken } from '@/helpers';
import { IProduct } from '@/interfaces/product';
import { INextAuthSessionModel } from '@/interfaces/authentication';
import { IAddToCartItem, IEditCartItemQuantity, IGetCartProduct, IGuestCartRequest, IGuestCartResponse } from '@/interfaces/cart';
import { getAxiosInstance } from '@/utils/axios-instance';

export const addToCart = async (item: IAddToCartItem, session?: INextAuthSessionModel | null): Promise<IProduct> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/cart`, item, getHeaderWithToken(session));
  return response.data;
};

export const editCartItemQuantity = async (item: IEditCartItemQuantity): Promise<IProduct> => {
  const response = await getAxiosInstance().put(`${APEX_API_URL}/api/cart`, item);
  return response.data;
};


export const getCart = async (
  session?: INextAuthSessionModel | null,
  storeIds?: string[]
): Promise<IGetCartProduct> => {
   const params = new URLSearchParams();
  storeIds?.forEach((id) => {
    params.append('storeIds', id);
  });

  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/cart?${params.toString()}`, {
    headers: {
      Authorization: 'Bearer ' + session?.accessToken,
    },
  
  });

  return response.data;
};

export const getGuestCart = async (payload: IGuestCartRequest): Promise<IGuestCartResponse> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/cart/guest`, payload);
  return response.data;
};

export const deleteFromCart = async (id: string): Promise<any> => {
  const body = {
    shoppingCartItemId: id,
  };
  const response = await getAxiosInstance().delete(`${APEX_API_URL}/api/cart`, { data: body });
  return response.data;
};
